import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuditHistoryComponent } from './components/audit-history/audit-history.component';

const routes: Routes = [
  {
    path: '',
    component: AuditHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuditHistoryRoutingModule {}
